import { render, staticRenderFns } from "./ToggleText.vue?vue&type=template&id=7be65c46&"
import script from "./ToggleText.vue?vue&type=script&lang=js&"
export * from "./ToggleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports